import { useEffect, useState } from "react";
import { postData } from "./Http/api";

const CasoEstado = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/CasoEstadoListar", {});

        const data = response.value.map((item) => ({
          idCasoEstado: item.idCasoEstado,
          idCasoEtapa: item.idCasoEtapa,
          descripcion: item.descripcion,
          activo: item.activo
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Estados:", ex);
        setRows([]);
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchCasoEstados = async (idCasoEtapa = null) => {
  try {
    const response = await postData("/CasoEstadoListar", {});
    const estados = (response?.value || []).map((item) => ({
      idCasoEstado: item.idCasoEstado,
      idCasoEtapa: item.idCasoEtapa,
      descripcion: item.descripcion,
      activo: item.activo,
    }));
    
    // Filtrar por etapa si se proporciona
    if (idCasoEtapa) {
      return estados.filter(e => e.idCasoEtapa === idCasoEtapa);
    }
    
    return estados;
  } catch (ex) {
    console.error("Error cargando Estados (helper):", ex);
    return [];
  }
};

export default CasoEstado;
